import { MultiSelect } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { Card } from '~/shared/components/Card';
import { ClearFilters } from '~/shared/components/ClearFilters';
import { useOptions } from '~/shared/components/RequestsFilters/hooks/useOptions';
import { Search } from '~/shared/components/Search';
import { ETolgeeNamespaces } from '~/shared/enums/ETolgeeNamespaces';
import { ETolgeeRequests } from '~/shared/enums/ETolgeeRequests';

export type RequestsFiltersProps = {
  search: string;
  onSearchChange: (value: string) => void;
  selectedSource?: string[];
  onSelectedSourceChange?: (value: string[]) => void;
  selectedCompany?: string[];
  onSelectedCompanyChange?: (value: string[]) => void;
  selectedOperation?: string[];
  onSelectedOperationChange?: (value: string[]) => void;
  selectedStatus?: string[];
  onSelectedStatusChange?: (value: string[]) => void;
  onClearFilters: () => void;
};

export function RequestsFilters({
  search,
  onSearchChange,
  selectedSource,
  onSelectedSourceChange,
  selectedCompany,
  onSelectedCompanyChange,
  selectedOperation,
  onSelectedOperationChange,
  selectedStatus,
  onSelectedStatusChange,
  onClearFilters
}: RequestsFiltersProps) {
  const { operationTypes, status, originSource, companies } = useOptions(
    !!onSelectedCompanyChange
  );

  const { t: tRequests } = useTranslate(ETolgeeNamespaces.REQUESTS);

  return (
    <Card.Root>
      <Card.Content className="border-t-0">
        <div className="flex gap-4 items-center flex-wrap">
          <Search value={search} onChange={onSearchChange} />

          {onSelectedSourceChange && (
            <div className="min-w-[200px] h-10">
              <MultiSelect
                maxChips={1}
                options={originSource}
                className="h-full"
                emptyMessage="..."
                isSearchable
                isClearable
                placeholder={tRequests(ETolgeeRequests.LIST_REQUEST_SOURCE)}
                onValueChange={onSelectedSourceChange}
                value={selectedSource}
              />
            </div>
          )}

          {onSelectedCompanyChange && (
            <div className="min-w-[200px] h-10">
              <MultiSelect
                maxChips={1}
                options={companies}
                className="h-full"
                emptyMessage="..."
                isSearchable
                isClearable
                placeholder={tRequests(ETolgeeRequests.LIST_COMPANY_NAME)}
                onValueChange={onSelectedCompanyChange}
                value={selectedCompany}
              />
            </div>
          )}

          {onSelectedOperationChange && (
            <div className="min-w-[200px] h-10">
              <MultiSelect
                maxChips={1}
                options={operationTypes}
                className="h-full"
                emptyMessage="..."
                isSearchable
                isClearable
                placeholder={tRequests(ETolgeeRequests.LIST_OPERATION_TYPE)}
                onValueChange={onSelectedOperationChange}
                value={selectedOperation}
              />
            </div>
          )}

          {onSelectedStatusChange && (
            <div className="min-w-[200px] h-10">
              <MultiSelect
                maxChips={1}
                options={status}
                className="h-full"
                emptyMessage="..."
                isSearchable
                isClearable
                placeholder={tRequests(ETolgeeRequests.LIST_STATUS)}
                onValueChange={onSelectedStatusChange}
                value={selectedStatus}
              />
            </div>
          )}

          <ClearFilters onClick={onClearFilters} />
        </div>
      </Card.Content>
    </Card.Root>
  );
}
